// Základ adresy skrineWebApi (cookie session, ne skrineWebserver JWT).
// Nastavuje se přes REACT_APP_API_URL v .env.development / .env.production.
//
// Fallback platí jen pro vývoj. V produkčním buildu se na něj spolehnout nedá:
// zabudoval by se do bundlu localhost a nasazená appka by volala API na počítači
// uživatele. Hlídá to i scripts/check-env.js před buildem; tohle je druhá pojistka
// pro případ, že by se bundl sestavil jinudy než přes `npm run build`.
const fallback = 'http://localhost:5181';

if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_API_URL) {
  throw new Error(
    'Chybí REACT_APP_API_URL — produkční build musí mít adresu API ' +
    '(zkopírujte .env.production.example do .env.production).'
  );
}

export const API_URL = process.env.REACT_APP_API_URL || fallback;
